import request from '@/utils/request'

// 查询离职申请列表
export function listBusinessTrip(query) {
    return request({
        url: '/bpm/businessTrip/findAll',
        method: 'post',
        data: query
    })
}
// 查询转正申请详细
export function initApply() {
    return request({
        url: '/bpm/businessTrip/initApply',
        method: 'get'
    })
}

// 修改转正申请
export function completeTask(data) {
    return request({
        url: '/bpm/businessTrip/completeTask',
        method: 'post',
        data: data
    })
}
// 查询离职申请详细
export function getBusinessTrip(id) {
    return request({
        url: '/bpm/businessTrip/findOne?id=' + id,
        method: 'post'
    })
}

export function getByProcessInstanceId(processInstanceId) {
    return request({
        url: '/bpm/businessTrip/getByProcessInstanceId?processInstanceId=' + processInstanceId,
        method: 'post'
    })
}

// 新增离职申请
export function addBusinessTrip(data) {
    return request({
        url: '/bpm/businessTrip/add',
        method: 'post',
        data: data
    })
}

// // 修改离职申请
// export function updateBusinessTrip(data) {
//     return request({
//         url: '/bpm/businessTrip/edit',
//         method: 'post',
//         data: data
//     })
// }

// 删除离职申请
export function delBusinessTrip(id) {
    return request({
        url: '/bpm/businessTrip/remove',
        method: 'post',
        data: id
    })
}

// 导出离职申请
export function exportBusinessTrip(query) {
    return request({
        url: '/bpm/businessTrip/export',
        method: 'post',
        data: query
    })
}
